import { DatePicker } from "antd";
import dayjs from "dayjs";
import React, { useRef } from "react";

import { CalendarArrow } from "@/Components/Icons/CalendarArrow";

const { RangePicker } = DatePicker;
/**
 * Function for rendering a calendar filter component.
 *
 * @param {Object} label - the label for the calendar filter
 * @param {String} dateFrom - the start date for the filter
 * @param {String} dateTo - the end date for the filter
 * @param {Function} handleChange - the function to handle changes in the filter
 * @return {JSX.Element} the rendered calendar filter component
 */
const CalendarFilter = ({
  label,
  dateFrom,
  dateTo,
  handleChange,
  disabledDate = null,
}) => {
  let calendarRef = useRef();
  return (
    <div className="grid gap-3">
      <label className="label font-normal text-black">{label}</label>
      <div className="grid gap-3 rounded-md border border-lightblue bg-white p-[14px] shadow-[0px_1px_6px_0px_#E7EFFB]">
        <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
          <label className="label font-normal text-black">From</label>
          <label className="label font-normal text-black">To</label>
        </div>
        <div
          className={`customRangePicker filter_RangePicker`}
          ref={calendarRef}
        >
          <RangePicker
            open={true}
            getPopupContainer={(trigger) => trigger.parentNode}
            suffixIcon={null}
            prevIcon={
              <span className="flex h-[24px] w-[24px] items-center justify-center rounded-lg !bg-[#EBEDF3] !text-black">
                <CalendarArrow />
              </span>
            }
            format={"DD-MM-YYYY"}
            value={[
              dateFrom ? dayjs(dateFrom, "DD-MM-YYYY") : null,
              dateTo ? dayjs(dateTo, "DD-MM-YYYY") : null,
            ]}
            onChange={(value) => {
              if (value === null) {
                handleChange({
                  dateFrom: "",
                  dateTo: "",
                });
                return;
              }
              let startDate = value[0] ? value[0].format("DD-MM-YYYY") : "";
              let endDate = value[1] ? value[1].format("DD-MM-YYYY") : "";
              handleChange({
                dateFrom: startDate,
                dateTo: endDate,
              });
            }}
            superPrevIcon={null}
            superNextIcon={null}
            nextIcon={
              <span className="flex h-[24px] w-[24px] -rotate-180 items-center justify-center rounded-lg !bg-[#EBEDF3] !text-black">
                <CalendarArrow />
              </span>
            }
            disabledDate={disabledDate} // Function to disable dates []
          />
        </div>
      </div>
    </div>
  );
};

export default CalendarFilter;
